<template>
  <div class="pt-2">
    <h3 class="h5" v-if="header" :class="headerClass">{{ header }}</h3>
    <div v-if="description" class="help-text">{{ description }}</div>
  </div>
</template>

<script>
export default {
  name: 'FormInputHeader',

  props: {
    header: {
      type: String,
    },

    description: {
      type: String,
      default: null
    },

    headerClass: {
      type: String,
      default: ''
    }
  },
};
</script>
